module.exports = __webpack_public_path__ + "static/media/stockhausen_nowald_8.7d9090d3.jpeg";